<div class="detail-dialog">

    <mat-tab-group [(selectedIndex)]="gardenTabIndex" class="tabs" dynamicHeight>

        @for (gardenId of gardenEntries; track gardenId) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="label">
                        <img alt="{{'GARDEN.' + gardenId.toUpperCase() | translate}}"
                              src="assets/images/garden/{{gardenId}}.webp">
                        {{ 'GARDEN.' + gardenId.toUpperCase() | translate }}
                    </div>
                </ng-template>
                <article class="description">
                    <h2>
                        {{ 'GARDEN.' + gardenId.toUpperCase() | translate }}
                    </h2>
                    <p [innerHTML]="'GARDEN_INFO.' + gardenId.toUpperCase()  | translate"></p>
                </article>
            </mat-tab>
        }

    </mat-tab-group>


</div>
